import { StyledWrapper } from './Divider.styles';

const Divider = (): JSX.Element => {
  return <StyledWrapper />;
};

export default Divider;
